import { render } from "./ProductPricingMarginPage.vue?vue&type=template&id=d4e305b8"
import script from "./ProductPricingMarginPage.vue?vue&type=script&lang=js"
export * from "./ProductPricingMarginPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__